import { Box, ToggleButton } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { FunctionComponent } from 'react';

import css from './index.module.scss';
import { ExternalResourceType } from '../../../services/externalResourcesSearch/common';
import { Article, Flag, SiteSearch, TaskAdd } from 'wix-ui-icons-common';
import { Reels, SiteContent, Terminal } from '@wix/wix-ui-icons-common';
import { DATA_HOOKS } from '../../../dataHooks';
import { ArticleType, TsUtils } from '@wix/answers-api';
import { SearchResultsFilter } from '../../../constants';

export type InternalResourceType =
  | SearchResultsFilter.ARTICLES
  | SearchResultsFilter.KNOWN_ISSUES
  | SearchResultsFilter.FEATURE_REQUESTS;

export type SearchFilterType = InternalResourceType | ExternalResourceType;

export type ExternalSearchFilterProps = {
  selectedFilter: SearchFilterType;
  onSelectExternalSearchFilter: (selectedFilter: SearchFilterType) => void;
};

export const ExternalSearchFilter: FunctionComponent<
  ExternalSearchFilterProps
> = ({ selectedFilter, onSelectExternalSearchFilter }) => {
  const { t } = useTranslation();
  const internalResourceArray = TsUtils.enumToArray(ArticleType).filter(
    (a) => a !== ArticleType.VIDEO
  );

  const externalResourcesArray = Object.values(
    ExternalResourceType
  ) as ExternalResourceType[];

  const filters = [
    ...internalResourceArray,
    ...externalResourcesArray,
  ] as unknown as SearchFilterType[];

  const filterToIcon: Record<SearchFilterType, JSX.Element> = {
    [SearchResultsFilter.ARTICLES]: <Article />,
    [SearchResultsFilter.FEATURE_REQUESTS]: <TaskAdd />,
    [SearchResultsFilter.KNOWN_ISSUES]: <Flag />,
    [ExternalResourceType.WIX_BLOG]: <SiteContent />,
    [ExternalResourceType.WIX_LEARN]: <Reels />,
    [ExternalResourceType.WIX_SEO_LEARN]: <SiteSearch />,
    [ExternalResourceType.WIX_VELO]: <Terminal />,
  };

  return (
    <Box direction="horizontal" className={css.externalSearchFilters}>
      {filters.map((externalSearchFilter) => (
        <ToggleButton
          key={externalSearchFilter}
          dataHook={`${DATA_HOOKS.EXTERNAL_SEARCH_FILTER_BUTTON}_${externalSearchFilter}`}
          size="small"
          onClick={() => onSelectExternalSearchFilter(externalSearchFilter)}
          selected={externalSearchFilter === selectedFilter}
          shape="pill"
          skin="dark"
          labelValue={t(`external-search.filer.${externalSearchFilter}`)}
          labelPlacement="end"
          border
        >
          {filterToIcon[externalSearchFilter]}
        </ToggleButton>
      ))}
    </Box>
  );
};
